export default "<mat-progress-bar color=\"warn\" mode=\"indeterminate\" *ngIf=\"loading == true\"></mat-progress-bar>\n<router-outlet></router-outlet>"